var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._t("default",null,{"product":this.$data.product,"pps":this.$data.pps,"quantityDiscount":this.$data.quantityDiscounts,"visibleProductActions":this.$data.visibleProductActions,"displayState":this.displayState})}
var staticRenderFns = []

export { render, staticRenderFns }